import React, { useState, useEffect } from "react";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import DOMPurify from "dompurify";
import htmlToDraft from "html-to-draftjs";
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslate } from 'react-admin';

export default function DisplayHTML({ value, open, handleClose, ...props }) {
  const translate = useTranslate()
  const [editorState, setEditorState] = useState(EditorState.createEmpty())

  useEffect(() => {
    if (value !== null && value !== undefined) {
      let editor = null;

      if (value) {
        const contentBlock = htmlToDraft(value);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          editor = EditorState.createWithContent(contentState);
        }
      } else {
        editor = EditorState.createEmpty();
      }

      setEditorState(editor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const createMarkup = (html) => {
    const htmlConverted = draftToHtml(convertToRaw(html.getCurrentContent()))
    return {
      __html: DOMPurify.sanitize(htmlConverted)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth={true}>
      <DialogTitle>{translate('ra.field.html')}</DialogTitle>
      <DialogContent>
        <div dangerouslySetInnerHTML={createMarkup(editorState)} />
      </DialogContent>
    </Dialog>
  )
}
